import { sessionStorage } from '@shared/helpers/storage'

const fromAppKey = 'kwcFromApp'
export const isFromApp = () => !!sessionStorage.getItem(fromAppKey)
export const fromAppToStorage = () => {
  sessionStorage.setItem(fromAppKey, '1')
}
